import { Injectable } from '@angular/core';
import { nameof, TwoWayAdapter, IModelMetadata, From } from '@bds/core';

export interface RtTripShopFormUK {
    carInit?: string;
    carNo?: string;
    shipDateTime?: Date;
    ormId?: number;
    rtTripOrmId?: number;
}

export class RtTripShopForm implements From<RtTripShopForm>, RtTripShopFormUK {
    constructor(
        public carInit?: string,
        public carNo?: string,
        public shipDateTime?: Date,
        public fleetId?: string,
        public businessGroup?: string,
        public cleanSafeEntry?: string,
        public locCity?: string,
        public locState?: string,
        public lastCommCode?: string,
        public prevTankTest?: Date,
        public tankTestDue?: Date,
        public prevValveTest?: Date,
        public valveTestDue?: Date,
        public valveType?: string,
        public prevCoilTest?: Date,
        public coilTestDue?: Date,
        public coilType?: string,
        public prevSparkTest?: Date,
        public sparkTestDue?: Date,
        public prevStubSillTest?: Date,
        public stubSillTestDue?: Date,
        public prevPaintDate?: Date,
        public paintDue?: Date,
        public paintType?: string,
        public paintCondition?: string,
        public prevLiningDate?: Date,
        public liningDue?: Date,
        public liningType?: string,
        public liningCondition?: string,
        public prevLiningTest?: Date,
        public liningTestDue?: Date,
        public inspect88b2Prev?: Date,
        public inspect88b2Due?: Date,
        public shellThicknessPrev?: Date,
        public shellThicknessDue?: Date,
        public lastMaintDate?: Date,
        public nextMaintDate?: Date,
        public date1FieldName?: string,
        public date1Prev?: Date,
        public date1Due?: Date,
        public date2FieldName?: string,
        public date2Prev?: Date,
        public date2Due?: Date,
        public date3FieldName?: string,
        public date3Prev?: Date,
        public date3Due?: Date,
        public date4FieldName?: string,
        public date4Prev?: Date,
        public date4Due?: Date,
        public date5FieldName?: string,
        public date5Prev?: Date,
        public date5Due?: Date,
        public date6FieldName?: string,
        public date6Prev?: Date,
        public date6Due?: Date,
        public date7FieldName?: string,
        public date7Prev?: Date,
        public date7Due?: Date,
        public date8FieldName?: string,
        public date8Prev?: Date,
        public date8Due?: Date,
        public date9FieldName?: string,
        public date9Prev?: Date,
        public date9Due?: Date,
        public date10FieldName?: string,
        public date10Prev?: Date,
        public date10Due?: Date,
        public routeCode?: string,
        public routeDscr?: string,
        public custNo?: string,
        public custFname?: string,
        public custLname?: string,
        public shopComments?: string,
        public userId?: string,
        public updateDate?: Date,
        public specialRequirements?: string,
        public additionalComments?: string,
        public ormId?: number,
        public rtTripOrmId?: number,
        public updateDateTime?: Date,
    ) {}
    from(trip: RtTripShopForm): RtTripShopForm {
        Object.keys(trip).forEach((k) => (this[k] = trip[k]));
        return this;
    }
}

export const relationship: IModelMetadata[] = [
    { client: nameof<RtTripShopForm>('carInit'), server: 'carInit' },
    { client: nameof<RtTripShopForm>('carNo'), server: 'carNo' },
    { client: nameof<RtTripShopForm>('shipDateTime'), server: 'shipDateTime' },
    { client: nameof<RtTripShopForm>('fleetId'), server: 'fleetId' },
    { client: nameof<RtTripShopForm>('businessGroup'), server: 'businessGroup' },
    { client: nameof<RtTripShopForm>('cleanSafeEntry'), server: 'cleanSafeEntry' },
    { client: nameof<RtTripShopForm>('locCity'), server: 'locCity' },
    { client: nameof<RtTripShopForm>('locState'), server: 'locState' },
    { client: nameof<RtTripShopForm>('lastCommCode'), server: 'lastCommCode' },
    { client: nameof<RtTripShopForm>('prevTankTest'), server: 'prevTankTest' },
    { client: nameof<RtTripShopForm>('tankTestDue'), server: 'tankTestDue' },
    { client: nameof<RtTripShopForm>('prevValveTest'), server: 'prevValveTest' },
    { client: nameof<RtTripShopForm>('valveTestDue'), server: 'valveTestDue' },
    { client: nameof<RtTripShopForm>('valveType'), server: 'valveType' },
    { client: nameof<RtTripShopForm>('prevCoilTest'), server: 'prevCoilTest' },
    { client: nameof<RtTripShopForm>('coilTestDue'), server: 'coilTestDue' },
    { client: nameof<RtTripShopForm>('coilType'), server: 'coilType' },
    { client: nameof<RtTripShopForm>('prevSparkTest'), server: 'prevSparkTest' },
    { client: nameof<RtTripShopForm>('sparkTestDue'), server: 'sparkTestDue' },
    { client: nameof<RtTripShopForm>('prevStubSillTest'), server: 'prevStubSillTest' },
    { client: nameof<RtTripShopForm>('stubSillTestDue'), server: 'stubSillTestDue' },
    { client: nameof<RtTripShopForm>('prevPaintDate'), server: 'prevPaintDate' },
    { client: nameof<RtTripShopForm>('paintDue'), server: 'paintDue' },
    { client: nameof<RtTripShopForm>('paintType'), server: 'paintType' },
    { client: nameof<RtTripShopForm>('paintCondition'), server: 'paintCondition' },
    { client: nameof<RtTripShopForm>('prevLiningDate'), server: 'prevLiningDate' },
    { client: nameof<RtTripShopForm>('liningDue'), server: 'liningDue' },
    { client: nameof<RtTripShopForm>('liningType'), server: 'liningType' },
    { client: nameof<RtTripShopForm>('liningCondition'), server: 'liningCondition' },
    { client: nameof<RtTripShopForm>('prevLiningTest'), server: 'prevLiningTest' },
    { client: nameof<RtTripShopForm>('liningTestDue'), server: 'liningTestDue' },
    { client: nameof<RtTripShopForm>('inspect88b2Prev'), server: 'inspect88b2Prev' },
    { client: nameof<RtTripShopForm>('inspect88b2Due'), server: 'inspect88b2Due' },
    { client: nameof<RtTripShopForm>('shellThicknessPrev'), server: 'shellThicknessPrev' },
    { client: nameof<RtTripShopForm>('shellThicknessDue'), server: 'shellThicknessDue' },
    { client: nameof<RtTripShopForm>('lastMaintDate'), server: 'lastMaintDate' },
    { client: nameof<RtTripShopForm>('nextMaintDate'), server: 'nextMaintDate' },
    { client: nameof<RtTripShopForm>('date1FieldName'), server: 'date1FieldName' },
    { client: nameof<RtTripShopForm>('date1Prev'), server: 'date1Prev' },
    { client: nameof<RtTripShopForm>('date1Due'), server: 'date1Due' },
    { client: nameof<RtTripShopForm>('date2FieldName'), server: 'date2FieldName' },
    { client: nameof<RtTripShopForm>('date2Prev'), server: 'date2Prev' },
    { client: nameof<RtTripShopForm>('date2Due'), server: 'date2Due' },
    { client: nameof<RtTripShopForm>('date3FieldName'), server: 'date3FieldName' },
    { client: nameof<RtTripShopForm>('date3Prev'), server: 'date3Prev' },
    { client: nameof<RtTripShopForm>('date3Due'), server: 'date3Due' },
    { client: nameof<RtTripShopForm>('date4FieldName'), server: 'date4FieldName' },
    { client: nameof<RtTripShopForm>('date4Prev'), server: 'date4Prev' },
    { client: nameof<RtTripShopForm>('date4Due'), server: 'date4Due' },
    { client: nameof<RtTripShopForm>('date5FieldName'), server: 'date5FieldName' },
    { client: nameof<RtTripShopForm>('date5Prev'), server: 'date5Prev' },
    { client: nameof<RtTripShopForm>('date5Due'), server: 'date5Due' },
    { client: nameof<RtTripShopForm>('date6FieldName'), server: 'date6FieldName' },
    { client: nameof<RtTripShopForm>('date6Prev'), server: 'date6Prev' },
    { client: nameof<RtTripShopForm>('date6Due'), server: 'date6Due' },
    { client: nameof<RtTripShopForm>('date7FieldName'), server: 'date7FieldName' },
    { client: nameof<RtTripShopForm>('date7Prev'), server: 'date7Prev' },
    { client: nameof<RtTripShopForm>('date7Due'), server: 'date7Due' },
    { client: nameof<RtTripShopForm>('date8FieldName'), server: 'date8FieldName' },
    { client: nameof<RtTripShopForm>('date8Prev'), server: 'date8Prev' },
    { client: nameof<RtTripShopForm>('date8Due'), server: 'date8Due' },
    { client: nameof<RtTripShopForm>('date9FieldName'), server: 'date9FieldName' },
    { client: nameof<RtTripShopForm>('date9Prev'), server: 'date9Prev' },
    { client: nameof<RtTripShopForm>('date9Due'), server: 'date9Due' },
    { client: nameof<RtTripShopForm>('date10FieldName'), server: 'date10FieldName' },
    { client: nameof<RtTripShopForm>('date10Prev'), server: 'date10Prev' },
    { client: nameof<RtTripShopForm>('date10Due'), server: 'date10Due' },
    { client: nameof<RtTripShopForm>('routeCode'), server: 'routeCode' },
    { client: nameof<RtTripShopForm>('routeDscr'), server: 'routeDscr' },
    { client: nameof<RtTripShopForm>('custNo'), server: 'custNo' },
    { client: nameof<RtTripShopForm>('custFname'), server: 'custFname' },
    { client: nameof<RtTripShopForm>('custLname'), server: 'custLname' },
    { client: nameof<RtTripShopForm>('shopComments'), server: 'shopComments' },
    { client: nameof<RtTripShopForm>('userId'), server: 'userId' },
    { client: nameof<RtTripShopForm>('updateDate'), server: 'updateDate' },
    { client: nameof<RtTripShopForm>('specialRequirements'), server: 'specialRequirements' },
    { client: nameof<RtTripShopForm>('additionalComments'), server: 'additionalComments' },
    { client: nameof<RtTripShopForm>('ormId'), server: 'ormId' },
    { client: nameof<RtTripShopForm>('rtTripOrmId'), server: 'rtTripOrmId' },
    { client: nameof<RtTripShopForm>('updateDateTime'), server: 'updateDateTime' },
];

@Injectable({
    providedIn: 'root',
})
export class RtTripShopFormAdapter extends TwoWayAdapter<RtTripShopForm> {
    constructor() {
        super();
    }
    public metadata: IModelMetadata[] = relationship;
}
